import { Donvi } from './donvi';

export class Congkhaingansach {
  id: number;
  stt: number;
  tenbaocao: string;
  nam: string;
  bieumau: string;
  so: string;
  kyhieu: string;
  ngaycongbo: Date;
  filedinhkem: string;
  loai: number;
  ghichu: string;
  dmdonvi: Donvi;
  dmdonviid: number;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;
  //tenfilegoc: string;
  getFiles : string[];
  //getFilesgoc: string[];
  maubaocao: string;
  ngayvanban: Date;
  linkweb: string;
}